module.exports = __webpack_public_path__ + "static/img/news2ab.08f0a089.jpg";